<div class="table-container">
  <p-table [value]="data()" [scrollable]="true" class="p-table-fixed">
    <ng-template #header>
      <tr>
        <th class="cursor-pointer w-[12rem]">
          <app-sort-header
            columnName="Nombre empresa"
            columnKey="BusinessName"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('BusinessName')"
          />
        </th>
        <th class="cursor-pointer w-[12rem]">
          <app-sort-header
            columnName="Nombre sede"
            columnKey="Name"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Name')"
          />
        </th>
        <th class="cursor-pointer w-[12rem]">
          <app-sort-header
            columnName="Dirección"
            columnKey="Address"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Address')"
          />
        </th>
        <th class="cursor-pointer w-[12rem]">
          <app-sort-header
            columnName="Ubicación"
            columnKey="Location"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Location')"
          />
        </th>
        <th class="w-[5rem]">Principal</th>
        <th class="w-[5rem]">Estado</th>
        @if([UserPermission.DELETE_OFFICE, UserPermission.UPDATE_OFFICE] | hasAnyPermission){
          <th class="w-[8rem]" pFrozenColumn alignFrozen="right">Acciones</th>
        }
      </tr>
    </ng-template>
    <ng-template #body let-office>
      <tr>
        <td>
          <app-business-logo [logoUrl]="office.BusinessLogoUrl" [name]="office.BusinessName" />
        </td>
        <td>{{ office.Name }}</td>
        <td>{{ office.Address }}</td>
        <td>
          <app-flag-image
            [countryIso2]="office.Location.Country"
            [stateName]="office.Location.State"
          />
        </td>
        <td>{{ office.IsMain ? 'Sí' : 'No' }}</td>
        <td class="text-center">{{ office.Status === 'ENABLED' ? 'Activo' : 'Inactivo' }}</td>
        @if([UserPermission.DELETE_OFFICE, UserPermission.UPDATE_OFFICE] | hasAnyPermission){
          <td pFrozenColumn alignFrozen="right">
            <p-button type="button" variant="text" (onClick)="displayRowActions($event, office)">
              <span class="material-symbols-outlined cursor-pointer"> more_vert </span>
            </p-button>
          </td>
        }
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="6">No se encontraron resultados</td>
      </tr>
    </ng-template>
  </p-table>

  <app-paginator
    [first]="first()"
    [rows]="rows()"
    [totalRecords]="totalRecords()"
    (pageChange)="pageChange.emit($event)"
  />

  <p-popover #popover (onHide)="selectedOffice = null">
    <ng-template #content>
      <div class="flex flex-col gap-4">
        <ul class="list-none p-0 m-0 flex flex-col">
          @for (action of actionsOptions; track $index) {
          <li
            class="flex items-center gap-2 px-2 py-3 hover:bg-emphasis cursor-pointer rounded-border"
            (click)="selectOption(action)"
          >
            <span class="font-medium">{{ action.label }}</span>
          </li>
          }
        </ul>
      </div>
    </ng-template>
  </p-popover>
</div>
